var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "40px",
    height: "40px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,4c-1.105,0 -2,0.895 -2,2v6c0,1.105 0.895,2 2,2h6c1.105,0 2,-0.895 2,-2v-6c0,-1.105 -0.895,-2 -2,-2zM18,4c-1.105,0 -2,0.895 -2,2v6c0,1.105 0.895,2 2,2h6c1.105,0 2,-0.895 2,-2v-6c0,-1.105 -0.895,-2 -2,-2zM6,16c-1.105,0 -2,0.895 -2,2v6c0,1.105 0.895,2 2,2h6c1.105,0 2,-0.895 2,-2v-6c0,-1.105 -0.895,-2 -2,-2zM18,16c-1.105,0 -2,0.895 -2,2v6c0,1.105 0.895,2 2,2h6c1.105,0 2,-0.895 2,-2v-6c0,-1.105 -0.895,-2 -2,-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.5012f276a53790ef672c9459392523ef.svg";
export { ForwardRef as ReactComponent };